import React from 'react';
import learn1 from '../../assets/work/learn.png';
import { BsFillArrowRightCircleFill } from 'react-icons/bs';
import learn2 from '../../assets/work/learnB.png';
import learn3 from '../../assets/work/learnFL.png';
import learn4 from '../../assets/work/learnRE.png';

const Learn = () => {
    return (
        <div className="bg-[#0a192f] mx-auto min-h-screen md:pt-44 pt-40">
      <h2 className="mb-12 flex justify-center md:text-5xl text-xl p-6 bg-stone-600 text-orange-500">
        FireShip. platform project details
      </h2>
      <div className="flex justify-center">
        <div className="text-5xl  md:max-w-4xl">
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={learn1} alt="FireShip Homepage" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Home Page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This is the FireShip code camp home page.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Courses and course categories are listed on the home page.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The homepage is attractive and responsive.
              </p>
            </div>
          </div>
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={learn2} alt="FireShip blog page" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Blog Page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This is the Fireship code camp page for blog.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Here, the entire blog will be published.
              </p>
            </div>
          </div>
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={learn3} alt="category" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Category page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This course page has been filtered by category.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Users can view specific category courses on this page of courses that have been filtered by category.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                The Get Premium Access button on this page allows users to access courses as well.
              </p>
            </div>
          </div>
          <div className=" card card-compact max-w-full bg-base-100 shadow-xl mb-8">
            <figure>
              <img src={learn4} alt="login page" />
            </figure>
            <div className="card-body">
              <h2 className="card-title text-3xl text-orange-600 underline-offset-8 underline">
                Login page
              </h2>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                This is the unique login page for the Fireship code camp.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                Google and Github are available for user login. If a user registered using their email password, they can log in using that email and password.
              </p>
              <p className="text-xl font-medium mb-3">
                <BsFillArrowRightCircleFill className="mr-2 text-orange-600 inline-block text-2xl" />
                An email address and a link to a profile image are both available on the register page. The website profile symbol will be changed with the profile photo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
};

export default Learn;